import React from "react";
import BrandStylesThumb from "components/BrandStyles/thumb";
import {BrandStylesResult} from "data/models/deliverables/brand-styles";
import {Button} from "flowbite-react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {DeepPartial} from "flowbite-react/dist/types/types";
import {FlowbiteButtonTheme} from "flowbite-react/dist/types/components/Button/Button";


type BrandStylesDeliverableProps = {
  businessName: string | null;
  brandStyles: BrandStylesResult | null;
  brandVoice: string | null;
  brandVoiceLoading: boolean;
  alternativeText: string;
  navigateToBrandAssets: (download: boolean) => void;
}


export default function BrandStylesDeliverable(
  {
    businessName,
    brandStyles,
    brandVoice,
    brandVoiceLoading,
    alternativeText,
    navigateToBrandAssets,
  }: BrandStylesDeliverableProps
) {

  const buttonTheme: DeepPartial<FlowbiteButtonTheme> = {
    "size": {
      "xs": "text-xs",
    },
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>, download: boolean) => {
    if (brandVoice === null) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    navigateToBrandAssets(download);
  }

  return (
      <div className={"flex flex-col"}>
        {brandStyles === null && <div className={"text-xl mb-4 font-bold text-center w-full"}>
          Brand Styles Guide Example
        </div>}
        <BrandStylesThumb
            brandStyles={brandStyles}
            businessName={businessName}
            brandVoice={brandVoice}
            brandVoiceLoading={brandVoiceLoading}
            alternativeText={alternativeText}
        />
        <div className={"grow flex mt-2 flex-row justify-end"}>
          <Button
              className={"ml-1 px-0 text-black bg-transparent enabled:hover:bg-transparent border-0 enabled:hover:border-0 items-start"}
              color={"blue"}
              theme={buttonTheme}
              size={"xs"}
              disabled={brandStyles === null}
              onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleClick(event, true)}
          >
            <div className={"flex flex-row text-sm font-semibold my-auto"}>Download your Brand Styles</div>
            <div className={"w-8 h-8 ml-4 rounded-full bg-bc-green py-2"}><FontAwesomeIcon icon={faDownload}
                                                                                           className={"text-white"}
                                                                                           size={"lg"}/></div>
          </Button>
        </div>
      </div>

  );
}
